module.exports = __webpack_public_path__ + "static/media/so-algo--sheep1.9588780f.jpg";